module.exports = __webpack_public_path__ + "media/images/countrysquared/ss-483a8878db9c97de5b586741eeb6c502.svg";